import { Alert, Button, Empty, Spin } from "@arco-design/web-react";
import { ExternalLink } from "lucide-react";
import { useState } from "react";

import { canUsePermission } from "../../../lib/auth";
import { useCurrentAuthUser } from "../../auth";
import { FULFILLMENT_ORDER_PERMISSIONS } from "../config";
import { useFulfillmentOrderReadOnlyRuntime } from "../runtime/useFulfillmentOrderReadOnlyRuntime";
import { FulfillmentOrderAgreementCard } from "./FulfillmentOrderAgreementCard";
import { FulfillmentOrderAgreementPreviewDrawer } from "./FulfillmentOrderAgreementPreviewDrawer";
import { FulfillmentOrderLinePool } from "./FulfillmentOrderLinePool";
import { filterFulfillmentLines, fulfillmentCategoryToFilters } from "../service";
import "./fulfillmentOrder.css";

/** 合同交接复用真实确认明细、供应商协议汇总和合同增减预览。 */
export function FulfillmentOrderReadOnlyPanel({ itineraryId }: { itineraryId: string }) {
  const user = useCurrentAuthUser().data;
  const canAccess = canUsePermission(user, FULFILLMENT_ORDER_PERMISSIONS.access);
  const runtime = useFulfillmentOrderReadOnlyRuntime(itineraryId, canAccess);
  const [filters, setFilters] = useState(() => fulfillmentCategoryToFilters("all", false));
  if (!canAccess) return <Alert type="warning" content="暂无确认件查看权限" />;
  if (runtime.loading) return <Spin tip="正在加载确认件" />;
  if (runtime.error) return <Alert type="error" content="确认件加载失败"
    action={<Button onClick={() => void runtime.retry()}>重试</Button>} />;
  if (!runtime.workspace) return <Empty description="当前行程暂无确认件" />;
  const { orders, lines } = runtime.workspace;
  const activeLines = lines.filter((line) => line.status === "active");
  return (
    <section className="order-handover-confirmation-quick-panel" aria-label="确认件">
      <header className="order-handover-confirmation-quick-panel__header">
        <h3>供应商合并合同（{orders.length} 份）</h3>
        <Button type="primary" icon={<ExternalLink size={15} />}
          href={`/supply-chain/fulfillment-orders/itineraries/${encodeURIComponent(itineraryId)}/enter`}
          target="_blank" rel="noopener noreferrer">进入确认件管理</Button>
      </header>
      <FulfillmentOrderAgreementCard orders={orders} lines={lines} onSelect={runtime.selectOrder} />
      <h3>确认明细（{activeLines.length} 条）</h3>
      <FulfillmentOrderLinePool key={itineraryId} readOnly lines={activeLines}
        visibleLines={filterFulfillmentLines(activeLines, filters)}
        filters={filters} onFiltersChange={setFilters} />
      <FulfillmentOrderAgreementPreviewDrawer visible={Boolean(runtime.selectedOrderId)}
        detail={runtime.detail.data ?? null} loading={runtime.detail.isLoading}
        error={runtime.detail.error} onClose={runtime.closeDetail}
        onRetry={() => void runtime.detail.refetch()} />
    </section>
  );
}
